export default __webpack_public_path__ + "static/media/tasklistA.232519a9.svg";